import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { Form, Divider, Tabs } from "antd";
import { connect } from "react-redux";
import _ from 'lodash';
import Popup from "./Popup/Popup";
import history from "../../../../../history/history";
import { updatePageStepToFinish, updateStepperIndex, editStepperIndex, updateStepperAllToFinish, resetStepperIndex } from "../../../../../actions/globalActions";
import { ButtonDisplay } from "./ButtonDisplay";
import AddressForm from "./AddressForm";
import DeliveryMethod from "./DeliveryMethod";
import {
  FormContainer,  
  AdvisoryFormWrapper,
  RowWrapper,  
  DisplayFlexSpaceMobile,
  SelectTabsWrapper,
  ButtonWrapper
} from "../styles";

import { DisplayFlex, PagesHeading  } from "../../../../../CommonComponents/commonStyles";
import {
  disableButton,
  isSecondaryAdvisor,
  jsonTempForStep1,
  resetFormData
} from "../../actions";
import { DividerWrap, SubContentWrap  } from "./RelatedContributor/styles";
import moment from "moment";
import TabsAdvisorSuccessor from "../Components/TabAdvisorSuccessor";
import { ErrorMessage } from "./ErrorMessage";
import { inputBlurValidation } from "../../Validations/inputValidation";
import { updateReducerAdvisor } from "../../actions";
import UserInfoForms from "./UserInfoForms";
import PhoneForm from "../../../../../CommonComponents/Forms/PhoneInputForm";
import EmailForm from "../../../../../CommonComponents/Forms/EmailInputForm";
import { getDateOfBirth, getAlert, mapContents } from "./UtilFunctions";
import regexMap from "../../../../../utils/regexMap";
import { initiateTracking, recordError } from "../../../../../utils/commonUtil";
import {ErrorHandling} from '../../errorHandling';
import { resetZipCode, resetAllZipFields } from "../../../../../CommonComponents/Zipcode/actions";
import { PillButtonGreen, PillButtonGreenWrap } from "../../Step2LegacyOptions/Components/Tabs/styles";
import * as CustomPropTypes from '../../DefaultPropTypes';
import { GeneralButton } from "../../../../../CommonComponents/Commons/commonComponents";

export class StepOneSetup extends Component {
  constructor(props) {
    super(props);    
    this.editChecker = false;    
    this.state = {
      disabled: {
        primaryTitleCounter: 0,
        primaryfirstNameCounter: 0,
        primarymiddleNameCounter: 0,
        primarylastNameCounter: 0,
        primarySuffixCounter: 0,
        primaryDOBCounter: 0,
        primaryGenderCounter: 0,
        primarySSNCounter: 0,
        primaryconfirmSSNCounter: 0
      },
      tempInfo: {},
      primaryAdvisor: {},
      secondaryAdvisor: {},
      tempToDisplayOnly: {
        primaryTitle: undefined,
        secondaryTitle: undefined,
        primarySuffix: undefined,
        secondarySuffix: undefined,
        primaryGender: undefined,
        secondaryGender: undefined
      },
      primaryConfirmSSN: "",
      secondaryConfirmSSN: "",
      advisorType: "Primary",
      titleDropDown: [],
      suffixDropDown: [],
      genderDropDown: [],
      phoneType: [],
      emailDropDown: [],
      addressDropDown: [],
      countryDropDown: [],
      statesDropDown: [],
      relationshipDropDown: [],
      tabs: [
        {
          index: 1,
          title: <TabsAdvisorSuccessor advisor="Primary Advisor" />,
          key: "Primary",
          phoneRef: React.createRef(),
          emailRef: React.createRef()
        }
      ],
      primaryErrors: {},
      secondaryErrors: {},
      secondaryActive: false,
      activeKey: "Primary",
      step1Edit: false,
      counterPrimaryAdvisor: 0,
      counterSecondaryAdvisor: 0,
      counterPrimaryEmailAdvisor: 0,
      counterPrimaryPhoneAdvisor: 0,
      counterPrimaryAddressAdvisor: 0,
      counterPrimaryRelatedDonor: 0,
      counterSecondaryEmailAdvisor: 0,
      counterSecondaryPhoneAdvisor: 0,
      counterSecondaryAddressAdvisor: 0,
      counterSecondaryRelatedDonor: 0,
      counterStepperUpadteIndex: 0,
      counterStepperEditIndex: 0,
      counterTempInfo: 0,
      show: false,
      type: "",
      showInfo: false,
      updateCounter: 0,
      checkedEmail: false,
      addressChecked: false,
      tempCheckBoxStatus: {},
      tempCheckBoxCounter: 0,
      alertsStatus: false,
      zipCodeInvalidFlagP: true,
      zipCodeInvalidFlagS: true,
      resetPopupContent: {
        heading: "Reset Information",
        line1: "Resetting will delete all entered information on the page",
        line2: "",
        continue: "continue",
        cancel: "No, take me back",
        type: "reset"
      },
      removePopupContent: {
        heading: "Remove secondary advisor",
        line1: "Are you sure you want to remove the secondary advisor?",
        line2: "",
        continue: "continue",
        cancel: "No, take me back",
        type: "remove"
      },
      exitPopupContent: {
        heading: "Exit",
        line1:
          "Exiting will discard all information in the flow. You will have to start the process again",
        line2: "",
        continue: "continue",
        cancel: "No, take me back",
        type: "exit"
      }
    };

    this.text = "Last four digits of SSN or PIN.";
  }

  checkedEmailChange = () => {
    this.setState({checkedEmail: !this.state.checkedEmail});
  }

  componentDidUpdate(props) {
    if(props.location.state 
      && props.location.state.tempCheckBoxStatus 
      && props.location.state.tempCheckBoxStatus.addressChecked){
        if(this.state.tempCheckBoxCounter === 0){
          let secondaryAdvisorData;
          if (props.stepperEditIndex.status) {
            secondaryAdvisorData = props.location.state.secondaryAdvisorForEdit.info;
            this.storeDataForCheckbox(props,secondaryAdvisorData);
          }
          if(props.stepperUpdateIndex.status){
            if(props.tempData.tempJSON.advisors[1]){              
              secondaryAdvisorData = props.tempData.tempJSON.advisors[1];
              this.storeDataForCheckbox(props,secondaryAdvisorData);              
            }
          }
        }
    }
    if (props.stepperEditIndex.status  && props.stepperEditIndex.index === 1) {
      this.userClicksOnStepperEdit(props);
    }
    if (props.stepperUpdateIndex.status && props.stepperUpdateIndex.index === 1) {
      this.userClickOnStep3Edit(props);
    }
  }

  storeZipCode(advisor,name){
    this.setState({[name]:advisor});
  }

  storeDataForCheckbox(props,secondaryAdvisorData){
    if(secondaryAdvisorData.firstname != null){
      let {addressChecked,emailChecked,confirmSSN} = props.location.state.tempCheckBoxStatus
      let tempCheckBoxCounter = this.state.tempCheckBoxCounter;
      tempCheckBoxCounter += 1;
      this.setState({tempCheckBoxCounter});
      this.setState({addressChecked,checkedEmail: emailChecked,secondaryConfirmSSN: confirmSSN});   
    }
  }

  stepperEditFix(props){
    let secondaryAdvisorData = props.secondaryAdvisorForEdit;
    let primaryAdvisorData = props.primaryAdvisorForEdit;    
    this.setState(prevState => ({
      primaryAdvisor: {
        ...primaryAdvisorData.info,
        emails: primaryAdvisorData.email,
        phones: primaryAdvisorData.phone,
        addresses: primaryAdvisorData.addresses,
        relatedDonor: primaryAdvisorData.relatedDonor
      },
      secondaryAdvisor: {
        ...secondaryAdvisorData.info,
        emails: secondaryAdvisorData.email,
        phones: secondaryAdvisorData.phone,
        addresses: secondaryAdvisorData.addresses
      },
      secondaryConfirmSSN: secondaryAdvisorData.info.ssn,
    }));
  }


  storingStateCity = (advisor,zipCodeData,type) => {  
    if(!_.isEmpty(advisor)){
      let errors = {};
      let errorName = '';
      if(type.includes("primary")){
        errors = JSON.parse(JSON.stringify(this.state.primaryErrors));
        errorName = 'primaryErrors';
      }else{
        errors = JSON.parse(JSON.stringify(this.state.secondaryErrors));
        errorName = 'secondaryErrors';
      }          
      advisor.addresses.length &&
      advisor.addresses.forEach((addr,i) => {        
        if(addr.zipTitle && zipCodeData[addr.zipTitle] && !zipCodeData[addr.zipTitle].loading 
          && zipCodeData[addr.zipTitle].city != addr.city){                             
            if(zipCodeData[addr.zipTitle].city){              
              addr.city = zipCodeData[addr.zipTitle].city;
              let stateObj = this.filterDropDownDataWithValue(zipCodeData[addr.zipTitle].state,this.state.statesDropDown);              
              addr.state = (stateObj && stateObj.value) ? stateObj.value : undefined;
              if(errors.city && Object.keys(errors.city).length && errors.city[i]){               
                this.setState(prevState => ({
                  [errorName]: {
                    ...prevState[errorName],
                    city: {
                      ...prevState[errorName].city,
                      [i]: null
                    }
                  }
                }))
              }
              if(errors.state && Object.keys(errors.state).length && errors.state[i]){                
                this.setState(prevState => ({
                  [errorName]: {
                    ...prevState[errorName],
                    state: {
                      ...prevState[errorName].state,
                      [i]: null
                    }
                  }
                }))
              }
            }else{
              addr.city = '';
              addr.state = '';
            }
        }
      })
      this.storeZipCode(advisor,type);
    }
  }
  

  componentWillReceiveProps(nextprops) {    
    this.setState({
      relationshipDropDown: nextprops.dropDown.relationship
        ? nextprops.dropDown.relationship
        : [],
      statesDropDown: nextprops.dropDown.states
        ? nextprops.dropDown.states
        : [],
      countryDropDown: nextprops.dropDown.countries
        ? nextprops.dropDown.countries
        : [],
      addressDropDown: nextprops.dropDown.addressType
        ? nextprops.dropDown.addressType
        : [],
      genderDropDown: nextprops.dropDown.gender
        ? nextprops.dropDown.gender
        : [],
      phoneType: nextprops.dropDown.phoneType
        ? nextprops.dropDown.phoneType
        : [],
      emailDropDown: nextprops.dropDown.emailType
        ? nextprops.dropDown.emailType
        : [],
      titleDropDown: nextprops.dropDown.title ? nextprops.dropDown.title : [],
      suffixDropDown: nextprops.dropDown.suffix ? nextprops.dropDown.suffix : []
    });

    if(!_.isEmpty(nextprops.zipCodeData)){     
      let primaryAdvisor = JSON.parse(JSON.stringify(this.state.primaryAdvisor));
      let secondaryAdvisor = JSON.parse(JSON.stringify(this.state.secondaryAdvisor));
      this.storingStateCity(primaryAdvisor,nextprops.zipCodeData,'primaryAdvisor');
			if(this.state.tabs.length === 2){        
        this.storingStateCity(secondaryAdvisor,nextprops.zipCodeData,'secondaryAdvisor');
      }
    }

    if(nextprops.tempInfo){      
      if(this.state.counterTempInfo === 0){        
        this.setState({
          tempInfo: nextprops.tempInfo
        })
        let counterTempInfo = this.state.counterTempInfo;
        counterTempInfo += 1;
        this.setState({counterTempInfo});
      }
    }

    if (nextprops.primaryAdvisorInfo) {      
      //Storing Primary advisor once only
      if (nextprops.stepperUpdateIndex.status) {        
        this.userClickOnStep3Edit(nextprops);
      } else {
        if (this.state.counterPrimaryAdvisor === 0) {          
          this.setState(
            {
              primaryAdvisor: nextprops.primaryAdvisorInfo,
            },
            () => {                                     
              if(nextprops.location.state 
                && nextprops.location.state.primaryAdvisorForEdit 
                && nextprops.location.state.primaryAdvisorForEdit.addresses){                               
                this.stepperEditFix(nextprops.location.state);
              }
              this.setState(prevState => ({
                primaryAdvisor: {
                  ...prevState.primaryAdvisor,
                  deliveryMethod: "E-Delivery"
                }
              }));
            }
          );
          let counterPrimary = this.state.counterPrimaryAdvisor;
          counterPrimary++;
          this.setState({ counterPrimaryAdvisor: counterPrimary });
        }
      }
    }

    if (nextprops.secondaryAdvisorInfo) {
      // Storing secondary advisor data once only
      if (nextprops.stepperUpdateIndex.status) {
        this.userClickOnStep3Edit(nextprops);
      }else{
        if (this.state.counterSecondaryAdvisor === 0) {
          this.setState(
            {
              secondaryAdvisor: nextprops.secondaryAdvisorInfo
            },
            () => {
              if(nextprops.location.state 
                && nextprops.location.state.secondaryAdvisorForEdit 
                && nextprops.location.state.secondaryAdvisorForEdit.addresses){
                this.stepperEditFix(nextprops.location.state);
              }
              this.setState(prevState => ({
                secondaryAdvisor: {
                  ...prevState.secondaryAdvisor,
                  deliveryMethod: "E-Delivery"
                }
              }));
            }
          );
          let counterSecondary = this.state.counterSecondaryAdvisor;
          counterSecondary++;
          this.setState({ counterSecondaryAdvisor: counterSecondary });
        }
      }
    }

    if (nextprops.primaryAdvisorEmail) {
      // Storing primary advisor email data once only
      if (this.state.counterPrimaryEmailAdvisor === 0 && !this.state.primaryAdvisor.emails) {
        this.setState(prevState => ({
          primaryAdvisor: {
            ...prevState.primaryAdvisor,
            emails: JSON.parse(JSON.stringify(nextprops.primaryAdvisorEmail))
          }
        }));
        let counterPrimary = this.state.counterPrimaryEmailAdvisor;
        counterPrimary++;
        this.setState({ primaryAdvisorEmail: counterPrimary });
      }
    }

    if (nextprops.secondaryAdvisorEmail) {
      // Storing secondary advisor email data once only
      if (this.state.counterSecondaryEmailAdvisor === 0) {
        this.setState(prevState => ({
          secondaryAdvisor: {
            ...prevState.secondaryAdvisor,
            emails: nextprops.secondaryAdvisorEmail
          }
        }));
        let counterPrimary = this.state.counterSecondaryEmailAdvisor;
        counterPrimary++;
        this.setState({ counterSecondaryEmailAdvisor: counterPrimary });
      }
    }

    if (nextprops.primaryAdvisorPhone) {
      // Storing primary advisor phone data once only
      if (this.state.counterPrimaryPhoneAdvisor === 0) {
        this.setState(prevState => ({
          primaryAdvisor: {
            ...prevState.primaryAdvisor,
            phones: nextprops.primaryAdvisorPhone
          }
        }));
        let counterPrimary = this.state.counterPrimaryPhoneAdvisor;
        counterPrimary++;
        this.setState({ counterPrimaryPhoneAdvisor: counterPrimary });
      }
    }

    if (nextprops.secondaryAdvisorPhone) {
      // Storing primary advisor phone data once only
      if (this.state.counterSecondaryPhoneAdvisor === 0) {
        this.setState(prevState => ({
          secondaryAdvisor: {
            ...prevState.secondaryAdvisor,
            phones: nextprops.secondaryAdvisorPhone
          }
        }));
        let counterPrimary = this.state.counterSecondaryPhoneAdvisor;
        counterPrimary++;
        this.setState({ counterSecondaryPhoneAdvisor: counterPrimary });
      }
    }

    if (nextprops.primaryAdvisorAddress) {
      // Storing primary advisor phone data once only
      if (this.state.counterPrimaryAddressAdvisor === 0) {
        this.setState(prevState => ({
          primaryAdvisor: {
            ...prevState.primaryAdvisor,
            addresses: nextprops.primaryAdvisorAddress
          }
        }));
        let counterPrimary = this.state.counterPrimaryAddressAdvisor;
        counterPrimary++;
        this.setState({ counterPrimaryAddressAdvisor: counterPrimary });
      }
    }

    if (nextprops.secondaryAdvisorAddress) {
      if (this.state.counterSecondaryAddressAdvisor === 0) {
        this.setState(prevState => ({
          secondaryAdvisor: {
            ...prevState.secondaryAdvisor,
            addresses: nextprops.secondaryAdvisorAddress
          }
        }));
        let counterPrimary = this.state.counterSecondaryAddressAdvisor;
        counterPrimary++;
        this.setState({ counterSecondaryAddressAdvisor: counterPrimary });
      }
    }
    
    if (this.state.counterPrimaryRelatedDonor === 0) {
      if(nextprops.primaryAdvisorRelatedDonor === null){
        this.setState(prevState => ({
          primaryAdvisor: {
            ...prevState.primaryAdvisor,
            relatedDonor: []
          }
        }));
      }
      let counterPrimary = this.state.counterPrimaryRelatedDonor;
      counterPrimary++;
      this.setState({ counterPrimaryRelatedDonor: counterPrimary });
    }
  }

  componentDidMount() {    
    if (this.props.dropDown.title) {
      this.setState({
        titleDropDown: this.props.dropDown.title
      });
    }
    
    if (this.props.primaryAdvisorInfo) {
      this.setState({
        primaryAdvisor: this.props.primaryAdvisorInfo
      });
    }
    if (this.props.secondaryAdvisorInfo) {
      this.setState({
        secondaryAdvisor: this.props.secondaryAdvisorInfo
      });
    }
  }

  userClicksOnStepperEdit(props) {    
    if (this.state.counterStepperEditIndex === 0) {
      let secondaryAdvisorData = props.location.state.secondaryAdvisorForEdit;
      let primaryAdvisorData = props.location.state.primaryAdvisorForEdit;
      if(props.tempInfo.firstname != "" || props.tempInfo.firstname != null){        
        this.setState({tempInfo: props.tempInfo})
      }
      if(secondaryAdvisorData.info.firstname != null){        
        if(this.state.tabs.length === 1){          
          this.handleAddAdvisorClick(true);
        }
      }
        this.setState(prevState => ({
          primaryAdvisor: {
            ...primaryAdvisorData.info,
            emails: primaryAdvisorData.email,
            phones: primaryAdvisorData.phone,
            addresses: primaryAdvisorData.addresses,
            relatedDonor: primaryAdvisorData.relatedDonor
          },
          secondaryAdvisor: {
            ...secondaryAdvisorData.info,
            emails: secondaryAdvisorData.email,
            phones: secondaryAdvisorData.phone,
            addresses: secondaryAdvisorData.addresses
          },
          secondaryConfirmSSN: secondaryAdvisorData.info.ssn,
          titleDropDown: props.dropDown.title,
          suffixDropDown: props.dropDown.suffix,
          genderDropDown: props.dropDown.gender,
          phoneType: props.dropDown.phoneType,
          emailDropDown: props.dropDown.emailType,
          addressDropDown: props.dropDown.addressType,
          countryDropDown: props.dropDown.countries,
          statesDropDown: props.dropDown.states,
          relationshipDropDown: props.dropDown.relationship
        }));
        let counter = this.state.counterStepperEditIndex;
        counter = counter + 1;
        this.setState({counterStepperEditIndex: counter})
    }
  }

  returnTempJSONAdvisors(props){
    let advisors = props.tempData.tempJSON.advisors;
    if(advisors[1] && advisors[1].firstname !== null){
      return advisors[1];
    }
    return props.secondaryAdvisorInfo;
  }

  analyticsTracking(event,eventCategory,buttonName){
    initiateTracking(event, 'Open Additional Account', eventCategory, buttonName);
  }

  userClickOnStep3Edit(props) {    
    if (this.state.counterStepperUpadteIndex === 0) {      
      this.setState({ step1Edit: true }, () => {        
        if(props.tempInfo.firstname != "" || props.tempInfo.firstname != null){          
          this.setState({tempInfo: props.tempInfo})
        }
        this.setState(
          prevState => ({
            primaryAdvisor: JSON.parse(JSON.stringify(props.tempData.tempJSON.advisors[0])),
            secondaryAdvisor:this.returnTempJSONAdvisors(props),
            titleDropDown: props.dropDown.title,
            suffixDropDown: props.dropDown.suffix,
            genderDropDown: props.dropDown.gender,
            phoneType: props.dropDown.phoneType,
            emailDropDown: props.dropDown.emailType,
            addressDropDown: props.dropDown.addressType,
            countryDropDown: props.dropDown.countries,
            statesDropDown: props.dropDown.states,
            relationshipDropDown: props.dropDown.relationship
          }),
          () => {
            if (props.tempData.tempJSON.advisors.length != 1 && props.tempData.tempJSON.advisors[1].firstname !== null) {              
              this.handleAddAdvisorClick(true);
            }
          }
        );
      });
      let counterStepperUpadteIndex = this.state.counterStepperUpadteIndex;
      counterStepperUpadteIndex = counterStepperUpadteIndex + 1;
      this.setState({ counterStepperUpadteIndex },() => {
        if(props.tempData.tempJSON.advisors.length > 1 && props.tempData.tempJSON.advisors[1].firstname !== null){          
          if(this.state.tabs.length === 1){            
            this.handleAddAdvisorClick(true);
          }
        }
      });
    }
  }

  activateUpdateButton(){
    let updateCounter = this.state.updateCounter;
    updateCounter += 1;
    this.setState({updateCounter});
  }

  // Storing Data for DatePicker
  handleDOBChange = (type, momentValue) => {    
    if(this.state.step1Edit){      
      this.activateUpdateButton(); // TO ACTIVATE UPDATE BUTTTON
    }
    if (type === "dob") {      
      if (this.state.advisorType === "Primary") {            
        this.setState(prevState => ({
          primaryAdvisor: {
            ...prevState.primaryAdvisor,
            [type]: !momentValue ? "" : moment(momentValue).format("MM/DD/YYYY")
          }
        }), () => {
          if(this.state.primaryAdvisor.dob){            
            this.setState(prevState => ({
              primaryErrors: {
                ...prevState.primaryErrors,
                [type]: {
                  ...prevState.primaryErrors[type],
                  [1]: null
                }
              }
            }))
          }
        });
      } else {            
        this.setState(prevState => ({
          secondaryAdvisor: {
            ...prevState.secondaryAdvisor,
            [type]: !momentValue ? "" : moment(momentValue).format("MM/DD/YYYY")
          }
        }),() => {          
          if(this.state.secondaryAdvisor.dob){            
            this.setState(prevState => ({
              secondaryErrors: {
                ...prevState.secondaryErrors,
                [type]: {
                  ...prevState.secondaryErrors[type],
                  [1]: null
                }
              }
            }))
          }
        });
      }
    }
  };

  //   Storing Data In State For Text box
  handleChange = e => {
    if(this.state.step1Edit){
      this.activateUpdateButton(); // TO ACTIVATE UPDATE BUTTTON
    }
    let index = e.target.name;
    let value = e.target.value;
    let reg = /[!@#$%^&*(),.?":{}|<>]/;
    //If This call is not for ConfirmSSN then follow else
    if (index === "confirmSSN") {
      if (this.state.advisorType === "Primary") {
        if (reg.test(value) === false) {
          this.setState(prevState => ({
            primaryConfirmSSN: value,
            disabled: {
              ...prevState.disabled,
              primaryconfirmSSNCounter:
                prevState.disabled.primaryconfirmSSNCounter + 1
            }
          }));
        }
        if (this.state.primaryErrors.confirmSSN && value.length > 3) {
          this.setState(prevState => ({
            primaryErrors: {
              ...prevState.primaryErrors,
              ["confirmSSN"]: {
                ...prevState.primaryErrors["confirmSSN"],
                [1]: null
              }
            }
          }));
        }
      } else {
        if (reg.test(value) === false) {
          this.setState({ secondaryConfirmSSN: value });
        }
        if (this.state.secondaryErrors.confirmSSN && value.length > 3) {
          this.setState(prevState => ({
            secondaryErrors: {
              ...prevState.secondaryErrors,
              ["confirmSSN"]: {
                ...prevState.secondaryErrors["confirmSSN"],
                [1]: null
              }
            }
          }));
        }
      }
    } else {
      if (this.state.advisorType === "Primary") {
        if (index === "ssn") {
          if (reg.test(value) === false) {
            this.setState(prevState => ({
              primaryAdvisor: {
                ...prevState.primaryAdvisor,
                [index]: value
              },
              disabled: {
                ...prevState.disabled,
                primarySSNCounter:
                  index === "ssn"
                    ? prevState.disabled.primarySSNCounter + 1
                    : prevState.disabled.primarySSNCounter
              }
            }));
          }
        } else {
          this.setState(prevState => ({
            primaryAdvisor: {
              ...prevState.primaryAdvisor,
              [index]: value
            }
          }));

          if (
            Object.prototype.hasOwnProperty.call(
              this.state.primaryErrors,
              index
            )
          ) {
            this.setState(prevState => ({
              primaryErrors: {
                ...prevState.primaryErrors,
                [index]: {
                  ...prevState.primaryErrors[index],
                  [1]: null
                }
              }
            }));
          }
        }
        if (this.state.primaryErrors.ssn && value.length > 3) {
          this.setState(prevState => ({
            primaryErrors: {
              ...prevState.primaryErrors,
              ["ssn"]: {
                ...prevState.primaryErrors["ssn"],
                [1]: null
              }
            }
          }));
        }
      } else {
        if (index === "ssn") {
          if (reg.test(value) === false) {

            if(value === this.state.secondaryConfirmSSN){
              this.setState(prevState => ({
                secondaryErrors: {
                  ...prevState.secondaryErrors,
                  confirmSSN: {
                    ...prevState.secondaryErrorsconfirmSSN,
                    [index]: null
                  }
                }
              }));
            }else{
              let ErrorMsg = ErrorMessage('confirmSSN');
              this.setState(prevState => ({
                secondaryErrors: {
                  ...prevState.secondaryErrors,
                  confirmSSN: {
                    ...prevState.secondaryErrorsconfirmSSN,
                    [index]: null
                  }
                }
              }));
            }

            this.setState(prevState => ({
              secondaryAdvisor: {
                ...prevState.secondaryAdvisor,
                [index]: value
              }
            }));
          }
        } else {
          this.setState(prevState => ({
            secondaryAdvisor: {
              ...prevState.secondaryAdvisor,
              [index]: value
            }
          }));
        }

        if (
          Object.prototype.hasOwnProperty.call(
            this.state.secondaryErrors,
            index
          )
        ) {
          this.setState(prevState => ({
            secondaryErrors: {
              ...prevState.secondaryErrors,
              [index]: {
                ...prevState.secondaryErrors[index],
                [1]: null
              }
            }
          }));
        }
      }
    }
  };

  // Add New Field For Phone Email Address
  handleAddNewField = type => {

    if (type === "relatedDonor") {
      this.analyticsTracking('buttonStep','Step 1 Provide account information','Add a contributor');
      let newrelatedDonor = { name: "", relationship: "" };
      let relatedDonorOriginalData = this.state.primaryAdvisor.relatedDonor;
      relatedDonorOriginalData.push(newrelatedDonor);

      this.setState(prevState => ({
        primaryAdvisor: {
          ...prevState.primaryAdvisor,
          relatedDonor: relatedDonorOriginalData
        }
      }));
    }


    if (this.state.advisorType === "Primary") {
      if (type === "phone") {
        let newPhoneField = {
          addressId: this.state.primaryAdvisor.phones.length,
          phonenumber: "",
          phonetype: undefined,
          primary: this.state.primaryAdvisor.phones.length === 0 ? true : false
        };
        let phoneOriginalData = this.state.primaryAdvisor.phones;
        phoneOriginalData.push(newPhoneField);

        this.setState(prevState => ({
          primaryAdvisor: {
            ...prevState.primaryAdvisor,
            phones: phoneOriginalData
          }
        }));
      }

      // add new email field
      if (type === "emails") {
        let newEmailField = {
          addressId: this.state.primaryAdvisor.emails.length,
          emailId: "",
          emailtype: undefined,
          primary: this.state.primaryAdvisor.emails.length === 0 ? true : false
        };
        let emailOriginalData = this.state.primaryAdvisor.emails;
        emailOriginalData.push(newEmailField);

        this.setState(prevState => ({
          primaryAdvisor: {
            ...prevState.primaryAdvisor,
            emails: emailOriginalData
          }
        }));
      }

      if (type === "address") {
        let newAddressField = {
          addressId: this.state.primaryAdvisor.addresses.length,
          addresstype: undefined,
          city: null,
          country: "0",
          line2: null,
          line3: null,
          primary: this.state.primaryAdvisor.addresses.length === 0 ? true : false,
          state: null,
          zipcode: null
        };
        let addressOriginalData = this.state.primaryAdvisor.addresses;
        addressOriginalData.push(newAddressField);
        this.setState(prevState => ({
          primaryAdvisor: {
            ...prevState.primaryAdvisor,
            addresses: addressOriginalData
          }
        }));
      }
    } else {
      if (type === "phone") {
        let newPhoneField = {
          addressId: this.state.secondaryAdvisor.phones.length,
          phonenumber: "",
          phonetype: "",
          primary: false
        };
        let phoneOriginalData = this.state.secondaryAdvisor.phones;
        phoneOriginalData.push(newPhoneField);

        this.setState(prevState => ({
          secondaryAdvisor: {
            ...prevState.secondaryAdvisor,
            phones: phoneOriginalData
          }
        }));
      }
      // add new email field
      if (type === "emails") {
        let newEmailField = {
          addressId: this.state.secondaryAdvisor.emails.length,
          emailId: "",
          emailtype: "",
          primary: false
        };
        let emailOriginalData = this.state.secondaryAdvisor.emails;
        emailOriginalData.push(newEmailField);

        this.setState(prevState => ({
          secondaryAdvisor: {
            ...prevState.secondaryAdvisor,
            emails: emailOriginalData
          }
        }));
      }

      if (type === "address") {
        let newAddressField = {
          addressId: this.state.secondaryAdvisor.addresses.length,
          addresstype: null,
          city: null,
          country: "0",
          line2: null,
          line3: null,
          primary: false,
          state: null,
          zipcode: null
        };
        let addressOriginalData = this.state.secondaryAdvisor.addresses;
        addressOriginalData.push(newAddressField);

        this.setState(prevState => ({
          secondaryAdvisor: {
            ...prevState.secondaryAdvisor,
            addresses: addressOriginalData
          }
        }));
      }
    }
  };

  // Storing Phone Email Dropdown Data
  handleDropDownChange = (index, type, errorType, value) => {
    if(this.state.step1Edit){
      this.activateUpdateButton(); // TO ACTIVATE UPDATE BUTTTON
    }
    if (this.state.advisorType === "Primary") {
      // for deleting error message
      if (errorType) {
        // delete this.state.primaryErrors.errorType;
        this.setState(prevState => ({
          primaryErrors: {
            ...prevState.primaryErrors,
            [errorType]: {
              ...prevState.primaryErrors[errorType],
              [index]: null
            }
          }
        }));
      }
      // For storing phone data
      if (type === "phones") {
        let phoneOriginalData = this.state.primaryAdvisor.phones;
        phoneOriginalData.forEach((val, i) => {
          if (i === index) {
            val.phonetype = value;
          }
        });
        this.setState(prevState => ({
          primaryAdvisor: {
            ...prevState.primaryAdvisor,
            phones: phoneOriginalData
          }
        }));
      }
      // For Storing Email Data
      if (type === "emails") {
        let emailOriginalData = this.state.primaryAdvisor.emails;
        emailOriginalData.forEach((val, i) => {
          if (i === index) {
            val.emailtype = value;
          }
        });
        this.setState(prevState => ({
          primaryAdvisor: {
            ...prevState.primaryAdvisor,
            emails: emailOriginalData
          }
        }));
      }

      // For Storing Addresses Data
      if (type == "addresses") {
        let addressOriginalData = this.state.primaryAdvisor.addresses;
        let removedAddressObjPA;
        addressOriginalData.forEach((val, i) => {
          if (i == index) {
            if(val.isAddrExist){
            removedAddressObjPA  = [{
            addressId:"",
            addressLine1: "",
            addressLine2: "",
            addressLine3: "",
            addressType: val.addresstype,
            city: "",
            country: "",
            primary: false,
            state: "",
            zipCode: ""
            }];
          }
          val.addresstype = value;
          }
        });
        this.setState(prevState => ({
          primaryAdvisor: {
            ...prevState.primaryAdvisor,
            addresses: addressOriginalData
          }
        }));
        let addr = this.state.primaryAdvisor.remAddressPA;
        if(addr){
        addr.push(removedAddressObjPA[0]);
        }else{
          addr = removedAddressObjPA;
        }
        this.setState(prevState => ({
          primaryAdvisor: {
            ...prevState.primaryAdvisor,
            remAddressPA: addr
          }
        }));

      }
    } else {
      // for deleting error message
      if (errorType) {
        this.setState(prevState => ({
          secondaryErrors: {
            ...prevState.secondaryErrors,
            [errorType]: {
              ...prevState.secondaryErrors[errorType],
              [index]: null
            }
          }
        }));
      }
      // For storing secondary phone type dropdown data
      if (type == "phones") {
        let phoneOriginalData = this.state.secondaryAdvisor.phones;
        phoneOriginalData.forEach((val, i) => {
          if (i == index) {
            val.phonetype = value;
          }
        });
        this.setState(prevState => ({
          secondaryAdvisor: {
            ...prevState.secondaryAdvisor,
            phones: phoneOriginalData
          }
        }));
      }
      // For Storing Email Data for secondary advisor
      if (type == "emails") {
        let emailOriginalData = this.state.secondaryAdvisor.emails;
        emailOriginalData.forEach((val, i) => {
          if (i == index) {
            val.emailtype = value;
          }
        });
        this.setState(prevState => ({
          secondaryAdvisor: {
            ...prevState.secondaryAdvisor,
            emails: emailOriginalData
          }
        }));
      }
      // For Storing Address Data for secondary advisor
      if (type == "addresses") {
        let addressesOriginalData = this.state.secondaryAdvisor.addresses;
        addressesOriginalData.forEach((val, i) => {
          if (i == index) {
            val.addresstype = value;
          }
        });
        this.setState(prevState => ({
          secondaryAdvisor: {
            ...prevState.secondaryAdvisor,
            addresses: addressesOriginalData
          }
        }));
      }
    }
    if (type == "relatedDonor") {
      let donorOriginalData = this.state.primaryAdvisor.relatedDonor;
      donorOriginalData.forEach((val, i) => {
        if (i == index) {
          let x = this.filterDropDownDataWithValue(
            value,
            this.state.relationshipDropDown
          );
          val.relationship = x.value;
        }
      });

      this.setState(prevState => ({
        primaryAdvisor: {
          ...prevState.primaryAdvisor,
          relatedDonor: donorOriginalData
        }
      }));
    }
  };

  //Storing Radio Button Checking
  handleRadioChange = (index, type, event) => {
    if(this.state.step1Edit){
      this.activateUpdateButton(); // TO ACTIVATE UPDATE BUTTTON
    }
    if (this.state.advisorType == "Primary") {
      if (type == "phones") {
        let phoneOriginalData = this.state.primaryAdvisor.phones;
        phoneOriginalData.forEach((val, i) => {
          if (i == index) {
            val.primary = true;
          } else {
            val.primary = false;
          }
        });
        this.setState(prevState => ({
          primaryAdvisor: {
            ...prevState.primaryAdvisor,
            phones: phoneOriginalData
          }
        }));
      }

      // radio change for emails
      if (type == "emails") {
        let emailsOriginalData = this.state.primaryAdvisor.emails;
        emailsOriginalData.forEach((val, i) => {
          if (i == index) {
            val.primary = true;
          } else {
            val.primary = false;
          }
        });
        this.setState(prevState => ({
          primaryAdvisor: {
            ...prevState.primaryAdvisor,
            emails: emailsOriginalData
          }
        }));
      }

      if (type == "address") {
        let addressOriginalData = this.state.primaryAdvisor.addresses;
        addressOriginalData.forEach((val, i) => {
          if (i == index) {
            val.primary = true;
          } else {
            val.primary = false;
          }
        });
        this.setState(prevState => ({
          primaryAdvisor: {
            ...prevState.primaryAdvisor,
            addresses: addressOriginalData
          }
        }));
      }

      if (type == "deliveryMethod") {
        this.setState(prevState => ({
          primaryAdvisor: {
            ...prevState.primaryAdvisor,
            deliveryMethod: index.target.value
          }
        }));
      }
    } else {
      if (type == "phones") {
        let phoneOriginalData = this.state.secondaryAdvisor.phones;
        phoneOriginalData.forEach((val, i) => {
          if (i == index) {
            val.primary = true;
          } else {
            val.primary = false;
          }
        });
        this.setState(prevState => ({
          secondaryAdvisor: {
            ...prevState.secondaryAdvisor,
            phones: phoneOriginalData
          }
        }));
      }
      // radio change for emails
      if (type == "emails") {
        let emailsOriginalData = this.state.secondaryAdvisor.emails;
        emailsOriginalData.forEach((val, i) => {
          if (i == index) {
            val.primary = true;
          } else {
            val.primary = false;
          }
        });
        this.setState(prevState => ({
          secondaryAdvisor: {
            ...prevState.secondaryAdvisor,
            emails: emailsOriginalData
          }
        }));
      }
      if (type == "address") {
        let addressOriginalData = this.state.secondaryAdvisor.addresses;
        addressOriginalData.forEach((val, i) => {
          if (i == index) {
            val.primary = true;
          } else {
            val.primary = false;
          }
        });
        this.setState(prevState => ({
          secondaryAdvisor: {
            ...prevState.secondaryAdvisor,
            addresses: addressOriginalData
          }
        }));
      }

      if (type == "deliveryMethod") {
        this.setState(prevState => ({
          secondaryAdvisor: {
            ...prevState.secondaryAdvisor,
            deliveryMethod: index.target.value
          }
        }));
      }
    }
  };

  // Storing Data For Primary Changes Of Phones,Email
  handleArrayChange = (index, types, event) => {
    if(this.state.step1Edit){
      this.activateUpdateButton(); // TO ACTIVATE UPDATE BUTTTON
    }
    let errorType = event.target.name;
    if (this.state.advisorType == "Primary") {
      //for removing error message
      if (errorType && event.target.value) {
        this.setState(prevState => ({
          primaryErrors: {
            ...prevState.primaryErrors,
            [errorType]: {
              ...prevState.primaryErrors[errorType],
              [index]: null
            }
          }
        }));
      }

      // for storing primary phone data
      if (types == "phones") {
        let phoneOriginalData = [...this.state.primaryAdvisor.phones];
        phoneOriginalData.forEach((val, i) => {
          if (i == index) {
            if (errorType == "phones") {
              if (event.target.value) {
                val.phonenumber = event.target.value;
              }
            }
          }
        });
        this.setState(prevState => ({
          primaryAdvisor: {
            ...prevState.primaryAdvisor,
            phones: phoneOriginalData
          }
        }));
      }
      // for storing primary emails data
      if (types == "emailId") {
        let emailOriginalData = this.state.primaryAdvisor.emails;
        emailOriginalData.forEach((val, i) => {
          if (i == index) {
            val.emailId = event.target.value;
          }
        });
        this.setState(prevState => ({
          primaryAdvisor: {
            ...prevState.primaryAdvisor,
            emails: emailOriginalData
          }
        }));
      }

      // for storing primary addresses data
      if (types == "addresses") {
        let addressOriginalData = this.state.primaryAdvisor.addresses;
        addressOriginalData.forEach((val, i) => {
          if (i == index) {
            if (event.target.name === "zipcode") {
              if(val.country == "0"){
                let reg = /^([-]|[0-9])*$/;
                if (reg.test(event.target.value) && event.target.value.length <= 20){
                  if (inputBlurValidation(event.target.value, "zipcode",val) === false){
                    val.city = null;
                    val.state = null;
                  }
                  val[event.target.name] = event.target.value;
                  val.zipTitle = event.target.title;
                }
              }else{
                val[event.target.name] = event.target.value;
              }
            } else {
              if(event.target.name === "state"){
                let reg = /[^a-zA-Z ]/;
                if (!reg.test(event.target.value)) {
                  val[event.target.name] = event.target.value;
                }
              }else if(event.target.name === "city"){
                let reg = regexMap.city;
                if (reg.test(event.target.value)) {
                  val[event.target.name] = event.target.value;
                }
              }else{
                val[event.target.name] = event.target.value;
              }
            }
          }
        });
        this.setState(prevState => ({
          primaryAdvisor: {
            ...prevState.primaryAdvisor,
            addresses: addressOriginalData
          }
        }));
      }
    } else {
      // for removing error message
      if (errorType && event.target.value) {
        this.setState(prevState => ({
          secondaryErrors: {
            ...prevState.secondaryErrors,
            [errorType]: {
              ...prevState.secondaryErrors[errorType],
              [index]: null
            }
          }
        }));
      }
      // for storing secondary phone number
      if (types == "phones") {
        let phoneOriginalData = this.state.secondaryAdvisor.phones;
        phoneOriginalData.forEach((val, i) => {
          if (i == index) {
            if (errorType == "phones") {
              if (event.target.value) {
                val.phonenumber = event.target.value;
              }
            }
          }
        });
        this.setState(prevState => ({
          secondaryAdvisor: {
            ...prevState.secondaryAdvisor,
            phones: phoneOriginalData
          }
        }));
      }
      // for storing secondary emails data
      if (types == "emailId") {
        let emailOriginalData = this.state.secondaryAdvisor.emails;
        emailOriginalData.forEach((val, i) => {
          if (i == index) {
            val.emailId = event.target.value;
          }
        });
        this.setState(prevState => ({
          secondaryAdvisor: {
            ...prevState.secondaryAdvisor,
            emails: emailOriginalData
          }
        }));
      }
      // for storing secondary addresses data
      if (types == "addresses") {
        let addressOriginalData = this.state.secondaryAdvisor.addresses;
        addressOriginalData.forEach((val, i) => {
          if (i == index) {
            if (event.target.name === "zipcode") {
              if(val.country == "0"){
                let reg = /^([-]|[0-9])*$/;
                if (reg.test(event.target.value)){
                  if (inputBlurValidation(event.target.value, "zipcode",val) === false){
                    val.city = null;
                    val.state = null;
                  }
                  val[event.target.name] = event.target.value;
                  val.zipTitle = event.target.title;
                }
              }else{
                val[event.target.name] = event.target.value;
              }
            } else {
              if(event.target.name === "state"){
                let reg = /[^a-zA-Z ]/;
                if (!reg.test(event.target.value)) {
                  val[event.target.name] = event.target.value;
                }
              }else if(event.target.name === "city"){
                let reg = regexMap.city;
                if (reg.test(event.target.value)) {
                  val[event.target.name] = event.target.value;
                }
              }else{
                val[event.target.name] = event.target.value;
              }
            }
          }
        });
        this.setState(prevState => ({
          secondaryAdvisor: {
            ...prevState.secondaryAdvisor,
            addresses: addressOriginalData
          }
        }));
      }
    }
    if (types == "relatedDonor") {
      let donorOriginalData = this.state.primaryAdvisor.relatedDonor;
      donorOriginalData.forEach((val, i) => {
        if (i == index) {
          val.name = event.target.value;
        }
      });
      this.setState(prevState => ({
        primaryAdvisor: {
          ...prevState.primaryAdvisor,
          relatedDonor: donorOriginalData
        }
      }));
    }
  };

  // Storing Data State and Country Dropdown
  dropDownHandleChange = (index, type, value) => {
    if(this.state.step1Edit){
      this.activateUpdateButton(); // TO ACTIVATE UPDATE BUTTTON
    }
    if (this.state.advisorType == "Primary") {
      let addressOriginalData = this.state.primaryAdvisor.addresses;
      //Error removal
      if (type && value) {
        this.setState(prevState => ({
          primaryErrors: {
            ...prevState.primaryErrors,
            [type]: {
              ...prevState.primaryErrors[type],
              [index]: null
            }
          }
        }));
      }
      if (type == "state") {
        addressOriginalData.forEach((val, i) => {
          if (i == index) {
            val[type] = this.filterDropDownDataWithValue(
              value,
              this.state.statesDropDown
            ).value;
          }
        });
      }

      if (type == "country") {
        addressOriginalData.forEach((val, i) => {
          if (i == index) {
            val.state = "";
            val.zipcode = "";
            val.city = "";
            val[type] = this.filterDropDownDataWithValue(
              value,
              this.state.countryDropDown
            ).value;
          }
        });
        if(this.state.primaryAdvisor.addresses[index].zipcode != ""){
          if (inputBlurValidation(this.state.primaryAdvisor.addresses[index].zipcode, "zipcode",this.state.primaryAdvisor.addresses[index])) {
            this.setState(prevState => ({
              primaryErrors: {
                ...prevState.primaryErrors,
                zipcode: {
                  ...prevState.primaryErrorszipcode,
                  [index]: null
                }
              }
            }));
          }else{
            if(this.state.primaryAdvisor.addresses[index].zipcode !== null){
              if(this.state.primaryAdvisor.addresses[index].zipcode.length != 0){
                let ErrorMsg = ErrorMessage('zipcode', "length");
                this.setState(prevState => ({
                  primaryErrors: {
                    ...prevState.primaryErrors,
                    zipcode: {
                      ...prevState.primaryErrorszipcode,
                      [index]: ErrorMsg
                    }
                  }
                }));
              }else{
                let ErrorMsg = ErrorMessage(type);
                this.setState(prevState => ({
                  primaryErrors: {
                    ...prevState.primaryErrors,
                    zipcode: {
                      ...prevState.primaryErrorszipcode,
                      [index]: ErrorMsg
                    }
                  }
                }));
              }
            }
          }
        }else{
          this.setState(prevState => ({
            primaryErrors: {
              ...prevState.primaryErrors,
              zipcode: {
                ...prevState.primaryErrorszipcode,
                [index]: null
              }
            }
          }));
        }
      }

      this.setState(prevState => ({
        primaryAdvisor: {
          ...prevState.primaryAdvisor,
          addresses: addressOriginalData
        }
      }));
    } else {
      let addressOriginalData = this.state.secondaryAdvisor.addresses;
      // Error removal
      if (type && value) {
        this.setState(prevState => ({
          secondaryErrors: {
            ...prevState.secondaryErrors,
            [type]: {
              ...prevState.secondaryErrors[type],
              [index]: null
            }
          }
        }));
      }
      if (type == "state") {
        addressOriginalData.forEach((val, i) => {
          if (i == index) {
            val[type] = this.filterDropDownDataWithValue(
              value,
              this.state.statesDropDown
            ).value;
          }
        });
      }

      if (type == "country") {
        addressOriginalData.forEach((val, i) => {
          if (i == index) {
            val.state = "";
             val.zipcode = "";
            val[type] = this.filterDropDownDataWithValue(
              value,
              this.state.countryDropDown
            ).value;
          }
        });
        if(this.state.secondaryAdvisor.addresses[index].zipcode !== null 
          && this.state.secondaryAdvisor.addresses[index].zipcode !== ""){
          if (inputBlurValidation(this.state.secondaryAdvisor.addresses[index].zipcode, "zipcode",this.state.secondaryAdvisor.addresses[index])) {
            this.setState(prevState => ({
              secondaryErrors: {
                ...prevState.secondaryErrors,
                zipcode: {
                  ...prevState.secondaryErrorszipcode,
                  [index]: null
                }
              }
            }));
          }else{
            let ErrorMsg = ErrorMessage('zipcode', "length");
            this.setState(prevState => ({
              secondaryErrors: {
                ...prevState.secondaryErrors,
                zipcode: {
                  ...prevState.secondaryErrorszipcode,
                  [index]: ErrorMsg
                }
              }
            }));
          }
        }else{
          this.setState(prevState => ({
            secondaryErrors: {
              ...prevState.secondaryErrors,
              zipcode: {
                ...prevState.secondaryErrorszipcode,
                [index]: null
              }
            }
          }));
        }
      }

      this.setState(prevState => ({
        secondaryAdvisor: {
          ...prevState.secondaryAdvisor,
          addresses: addressOriginalData
        }
      }));
    }
  };

  //   Storing Data For Dropdowns
  onChange = (e, index) => {
    if(this.state.step1Edit){
      this.activateUpdateButton(); // TO ACTIVATE UPDATE BUTTTON
    }
    if (e == "title") {
      //Getting Value for Title DropDown
      index = this.filterDropDownDataWithValue(
        index,
        this.state.titleDropDown,
        e
      );
    }

    if (e == "suffix") {
      //Getting Value for Suffix DropDown
      index = this.filterDropDownDataWithValue(
        index,
        this.state.suffixDropDown,
        e
      );
    }

    if (e == "gender") {
      index = this.filterDropDownDataWithValue(
        index,
        this.state.genderDropDown,
        e
      );

      if (this.state.advisorType == "Primary") {
        this.setState(prevState => ({
          disabled: {
            ...prevState.disabled,
            primaryGenderCounter: prevState.disabled.primaryGenderCounter + 1
          }
        }));
      }
    }

    if (this.state.advisorType == "Primary") {
      this.setState(prevState => ({
        primaryAdvisor: {
          ...prevState.primaryAdvisor,
          [e]: index.value
        },
        tempToDisplayOnly: {
          ...prevState.tempToDisplayOnly,
          primaryTitle:
            e == "title"
              ? index.desc
              : prevState.tempToDisplayOnly.primaryTitle,
          primarySuffix:
            e == "suffix"
              ? index.desc
              : prevState.tempToDisplayOnly.primarySuffix,
          primaryGender:
            e == "gender"
              ? index.desc
              : prevState.tempToDisplayOnly.primaryGender
        },
        counter: prevState.counter + 1
      }));
    } else {
      this.setState(prevState => ({
        secondaryAdvisor: {
          ...prevState.secondaryAdvisor,
          [e]: index.value
        },
        tempToDisplayOnly: {
          ...prevState.tempToDisplayOnly,
          secondaryTitle:
            e == "title"
              ? index.desc
              : prevState.tempToDisplayOnly.secondaryTitle,
          secondarySuffix:
            e == "suffix"
              ? index.desc
              : prevState.tempToDisplayOnly.secondarySuffix,
          secondaryGender:
            e == "gender"
              ? index.desc
              : prevState.tempToDisplayOnly.secondaryGender
        }
      }));
    }
  };

  //   Generating Secondary Advisor
  handleAddAdvisorClick(flag) {
    try {
      this.analyticsTracking('buttonStep', 'Step 1 Provide account information', 'Add Advisor');
      this.editChecker = true;
      window.scrollTo(0, 0);
      
      let tabs = [...this.state.tabs];
      this.setState({ secondaryActive: true });
      let pAdvisorTemp = this.state.primaryAdvisor;
      
        //Condition During Update From Step 3
        if (flag == true) {
  
          this.setState({ activeKey: "Secondary" }, () => {
            tabs.push({
              index: 2, 
              title: <TabsAdvisorSuccessor advisor="Secondary Advisor" />,
              key: this.state.activeKey,
              phoneRef: React.createRef(),
              emailRef: React.createRef()
            });
            this.setState({ tabs }, () => {
              this.setState({ advisorType: "Secondary" });
              this.props.disableButton({
                disable: true
              });
              this.props.isSecondaryAdvisor({
                isSecondaryAdvisor: true
              });
              this.onChangeTabs('Primary')
            });
          });
        } else {
          this.setState(prevState => ({
            secondaryAdvisor:{
              ...prevState.secondaryAdvisor,
              addresses: [{
                addressId: 0,
                addresstype: undefined,
                city: null,
                country:"0",
                line1: null,
                line2: null,
                line3: null,
                state: undefined,
                zipcode: null,
                primary: true
              }],
              emails: [],
              phones: []
            },
            counterSecondaryAdvisor: 1,
            counterSecondaryEmailAdvisor: 1,
            counterSecondaryPhoneAdvisor: 1,
            counterSecondaryAddressAdvisor: 1,
            counterSecondaryRelatedDonor: 1,
            counterStepperUpadteIndex: 1,
          }),() => {
            this.setState({ activeKey: "Secondary" }, () => {
              tabs.push({
                index: 2, 
                title: <TabsAdvisorSuccessor advisor="Secondary Advisor" />,
                key: this.state.activeKey,
                phoneRef: React.createRef(),
                emailRef: React.createRef()
              });
              this.setState({ tabs }, () => {                
                this.setState({ advisorType: "Secondary" });               
                this.props.disableButton({
                  disable: true
                });
                this.props.isSecondaryAdvisor({
                  isSecondaryAdvisor: true
                });
              });
            });
          })
        }
    } catch (error) {
      recordError(error);
    }
  }

  // Removing Secondary Advisor with a modal confirm
  handleRemoveAdvisorClick = () => {
    try {
      this.props.disableButton({
        disable: false
      });
      this.props.isSecondaryAdvisor({
        isSecondaryAdvisor: false
      });
      this.setState({
        show: !this.state.show,
        secondaryActive: false,
        type: "remove"
      });
    } catch (error) {
      recordError(error);
    }
  };

  // Removing secondary advisor tabs
  removeTab() {
    this.analyticsTracking('remove', 'Step 1 Provide account information', 'Remove Advisor');
    this.activateUpdateButton();
    let tabs = this.state.tabs;
    this.setState({ activeKey: "Primary" }, () => {
      tabs.pop();
      let blankSecondary = {
        addresses: [{
          addresstype: "",
          city: "",
          country: "0",
          key: 0,
          line1: "",
          line2: "",
          line3: "",
          primary: true,
          state: "",
          zipcode: "",
        }],
        confirmSSN: "",
        deliveryMethod: "E-Delivery",
        dob: "",
        emails: [{
          emailId: "",
          emailtype: "",
          key: 0,
          primary: true
        }],
        firstname: "",
        gender: "",
        key: 0,
        lastname: "",
        middlename: "",
        phones: [{
          key: 0,
          phonenumber: "",
          phonetype: "",
          primary: true
        }],
        ssn: "",
        suffix: "",
        title: ""
      }
      this.setState(prevState => ({
        tabs: tabs,
        advisorType: "Primary",
        secondaryAdvisor: blankSecondary,
        tempToDisplayOnly: {
          ...prevState.tempToDisplayOnly,
          secondaryTitle: undefined,
          secondarySuffix: undefined,
          secondaryGender: undefined
        },
        addressChecked: false,
        checkedEmail: false,
        secondaryConfirmSSN: ''
      }),() => {
        this.closeModal();
        this.validateForms();
      })
    });
  }

  // Removing phone Emaild Address
  handleRemove = (index, type, errorTypes) => {
    this.activateUpdateButton();

    // remove related contributor from primary advisor
    if (type == "relatedContributor") {
      this.analyticsTracking('remove', 'Step 1 Provide account information', 'Remove Contributor');
      let relatedContributorData = [];
      let relatedOriginalData = this.state.primaryAdvisor.relatedDonor;
      relatedOriginalData.forEach((val, i) => {
        if (i != index) {
          relatedContributorData.push(val);
        }
      });
      this.setState(prevState => ({
        primaryAdvisor: {
          ...prevState.primaryAdvisor,
          relatedDonor: relatedContributorData
        }
      }));
    }


    if (this.state.advisorType == "Primary") {
      //Error Handling
      if (errorTypes.length > 0) {
        errorTypes.forEach(item => {
          this.setState(prevState => ({
            primaryErrors: {
              ...prevState.primaryErrors,
              [item]: {
                ...prevState.primaryErrors[item],
                [index]: null
              }
            }
          }));
        });
      }

      if (type == "phone") {
        let phonesNewData = [];
        let phoneOriginalData = this.state.primaryAdvisor.phones;
        phoneOriginalData.forEach((val, i) => {
          if (i != index) {
            phonesNewData.push(val);
          }
        });
        this.setState(prevState => ({
          primaryAdvisor: {
            ...prevState.primaryAdvisor,
            phones: phonesNewData
          }
        }));
      }

      //remove email for primary advisor
      if (type == "emails") {
        let emailsNewData = [];
        let emailOriginalData = this.state.primaryAdvisor.emails;
        emailOriginalData.forEach((val, i) => {
          if (i != index) {
            emailsNewData.push(val);
          }
        });
        this.setState(prevState => ({
          primaryAdvisor: {
            ...prevState.primaryAdvisor,
            emails: emailsNewData
          }
        }));
      }

      //remove email for primary advisor
      if (type == "address") {
        let addressNewData = [];
        let removedAddressObjPA;
        let addressOriginalData = this.state.primaryAdvisor.addresses;
        addressOriginalData.forEach((val, i) => {
          if (i != index) {
            addressNewData.push(val);
          } else {
            if(val.isAddrExist){
            removedAddressObjPA  = [{
            addressId:"",
            addressLine1: "",
            addressLine2: "",
            addressLine3: "",
            addressType: val.addresstype,
            city: "",
            country: "",
            primary: false,
            state: "",
            zipCode: ""
            }];
          }
          }
        });
        this.setState(prevState => ({
          primaryAdvisor: {
            ...prevState.primaryAdvisor,
            addresses: addressNewData
          }
        }));
        let addr = this.state.primaryAdvisor.remAddressPA;
        if(addr){
        addr.push(removedAddressObjPA[0]);
        }else{
          addr = removedAddressObjPA;
        }
        this.setState(prevState => ({
          primaryAdvisor: {
            ...prevState.primaryAdvisor,
            remAddressPA: addr
          }
        }));
      }
      
    } else {
      //Error Handling
      if (errorTypes.length > 0) {
        errorTypes.forEach(item => {
          this.setState(prevState => ({
            secondaryErrors: {
              ...prevState.secondaryErrors,
              [item]: {
                ...prevState.secondaryErrors[item],
                [index]: null
              }
            }
          }));
        });
      }

      if (type == "phone") {
        let phonesNewData = [];
        let phoneOriginalData = this.state.secondaryAdvisor.phones;
        phoneOriginalData.forEach((val, i) => {
          if (i != index) {
            phonesNewData.push(val);
          }
        });
        this.setState(prevState => ({
          secondaryAdvisor: {
            ...prevState.secondaryAdvisor,
            phones: phonesNewData
          }
        }));
      }
      //remove email for primary advisor
      if (type == "emails") {
        let emailsNewData = [];
        let emailOriginalData = this.state.secondaryAdvisor.emails;
        emailOriginalData.forEach((val, i) => {
          if (i != index) {
            emailsNewData.push(val);
          }
        });
        this.setState(prevState => ({
          secondaryAdvisor: {
            ...prevState.secondaryAdvisor,
            emails: emailsNewData
          }
        }));
      }

      if (type == "address") {
        let addressNewData = [];
        let addressOriginalData = this.state.secondaryAdvisor.addresses;
        addressOriginalData.forEach((val, i) => {
          if (i != index) {
            addressNewData.push(val);
          }
        });
        this.setState(prevState => ({
          secondaryAdvisor: {
            ...prevState.secondaryAdvisor,
            addresses: addressNewData
          }
        }));
      }
    }
  };

  //Filtering dropdown data for pre-filled values with value
  filterDropDownDataWithValue(value, dropdown, field) {
    if (value != "" && dropdown && dropdown.length != 0) {
      let desc = dropdown.filter(val => {
        return val.desc == value;
      });
      if (desc != undefined) {
        return desc[0];
      } else {
        return null;
      }
    }
  }

  //Fitering dropdown data for prefilled values with ID
  filterDropDownData(value, dropdown, field) {
    if (value != "" && value != null && dropdown.length != 0) {
      let desc = dropdown.filter(val => {
        return val.value == value;
      });
      if (desc != undefined) {
        return desc[0].desc;
      } else {
        return null;
      }
    }
  }

  // Get Gender Display Value
  getGenderDesc(value) {    
    if (this.state.genderDropDown.length != 0) {      
      let desc = this.state.genderDropDown.filter(val => {
        return val.value == value;
      });      
      if (desc && desc.length > 0) {
        return desc[0].desc;
      } else {
        return null;
      }
    }
  }

  // Secondary Advisor Same Address
  sameAddr = event => {
    this.setState({addressChecked:!this.state.addressChecked});
    if (event.target.checked) {
      let primaryAddress = [];      
      let tempPrimaryAdvisorAddress = JSON.parse(JSON.stringify(this.state.primaryAdvisor.addresses));     
     
      tempPrimaryAdvisorAddress.forEach(val => {
        if(val.primary){          
          primaryAddress.push(val)
        }
      })    

      let secondaryErrors = Object.assign({},this.state.secondaryErrors);          
      if(primaryAddress[0].addresstype && secondaryErrors.addressType && secondaryErrors.addressType[0]){             
        secondaryErrors.addressType[0] = null;
      }
      if(primaryAddress[0].line1 && secondaryErrors.line1 && secondaryErrors.line1[0]){        
        secondaryErrors.line1[0] = null;
      }
      if(primaryAddress[0].city && secondaryErrors.city && secondaryErrors.city[0]){       
        secondaryErrors.city[0] = null;
      }
      if(primaryAddress[0].state && secondaryErrors.state && secondaryErrors.state[0]){        
        secondaryErrors.state[0] = null;
      }
      if(primaryAddress[0].zipcode && secondaryErrors.zipcode && secondaryErrors.zipcode[0]){        
        secondaryErrors.zipcode[0] = null;
      }

      this.setState(prevState => ({
        secondaryAdvisor: {
          ...prevState.secondaryAdvisor,
          addresses: primaryAddress
        },
        secondaryErrors: secondaryErrors
      }));


    } else {
      this.setState(prevState => ({
        secondaryAdvisor: {
          ...prevState.secondaryAdvisor,
          addresses: [
            {
              addresstype: "",
              city: "",
              country: "0",
              key: 0,
              line1: "",
              line2: "",
              line3: "",
              primary: true,
              state: "",
              zipcode: ""
            }
          ]
        }
      }));
    }
  };

  //Final work to make things go back to normal
  goToNextStep() {
    try {
      // Storing The Data in Primary And Secondary Advior in Reducers
      let dataManipulation = [];
      if (this.state.secondaryAdvisor.firstname != "") {

        let tempData = {
          addressChecked:this.state.addressChecked,
          emailChecked: this.state.checkedEmail,
          confirmSSN: this.state.secondaryConfirmSSN,
        }
        dataManipulation = [
          this.state.primaryAdvisor,
          this.state.secondaryAdvisor,
          tempData
        ];
      } else {
        dataManipulation = [this.state.primaryAdvisor];
      }
      this.props.updateReducerAdvisor(dataManipulation);

      if(this.props.tempData 
        && this.props.tempData.tempJSON 
        && this.props.tempData.tempJSON.advisors){
          this.props.jsonTempForStep1(dataManipulation);
      }

      this.props.editStepperIndex({
        status : false,
        index: 1
      })
      this.updateStepper(true);
      history.push("/open-an-additional-account/legacy-options/");
    } catch (error) {
      recordError(error);
    }
  }

  updateStepper(flag){
    let stepperConfig = [
      {
        key: 1,
        description: 'Provide account information',
        status: 'finish',
        route: '/open-an-additional-account/account-information/',
        pageName: 'step1Setup',
      },
      {
        key: 2,
        description: 'Legacy options',
        status: flag ? "process" : "finish",
        route: '/open-an-additional-account/legacy-options/',
        pageName: 'step2Legacy',
      },
      {
        key: 3,
        description: 'Review and Submit',
        status: flag ? "wait" : "process",
        route: '/open-an-additional-account/review/',
        pageName: 'step3Review',
      },
    ];
    this.props.updateStepperAllToFinish(stepperConfig);
  }

  // When User Is In Update Stage
  goToFinalStep() {
    try {
      this.analyticsTracking('update','Step 1 Provide account information','Update');
      // Storing The Data in Primary And Secondary Advior in Reducers
      let dataManipulation = [];
      if (this.state.secondaryAdvisor.firstname != "") {
        let tempData = {
          addressChecked:this.state.addressChecked,
          emailChecked: this.state.checkedEmail,
          confirmSSN: this.state.secondaryConfirmSSN,
        }
        dataManipulation = [
          this.state.primaryAdvisor,
          this.state.secondaryAdvisor,
          tempData
        ];
      } else {
        dataManipulation = [this.state.primaryAdvisor];
      }
      
      
      this.props.updateReducerAdvisor(dataManipulation);
      this.props.jsonTempForStep1(dataManipulation);
      this.props.updateStepperIndex({
        status : false,
        index: 1
      })
      this.props.editStepperIndex({
        status : false,
        index: 1
      })
      this.updateStepper(false);
      history.push("/open-an-additional-account/review/");
    } catch (error) {
      recordError(error);
    }
  }

  handleExit = () => {
    window.scrollTo(0, 0);
    this.setState({
      show: true,
      type: "exit"
    });
  };

  checkForFirstName(name){
    if(name === null || name === undefined || name === ""){
      return true;
    }
    return false;
  }

  goDirectFinalStep() {
    try {
      this.analyticsTracking('cancel','Step 1 Provide account information','Cancel');
      if(this.state.secondaryAdvisor && this.checkForFirstName(this.state.secondaryAdvisor.firstname)){
        this.props.disableButton({
          disable: false
        });
      }
      this.props.updateStepperIndex({
        status : false,
        index: 1
      })
      history.push("/open-an-additional-account/review/");
    } catch (error) {
      recordError(error);
    }
  }

  // Rendering Tabs header and footer Which includes tabs padding and bottom next/update buttons
  renderingHeaderAndFooter({ key: tabKey, emailRef, phoneRef }) {
   
    let inputElm = {};
    let emailInput = {};
    let sel = this.state.advisorType === "Primary" ? 'advone_phn': "advsec_phn";
    let emailSel = this.state.advisorType === "Primary" ? 'advone_email': "advsec_email";

    inputElm.primary = `${sel}_primary`;
    inputElm.mobile = `${sel}_mobile`;
    inputElm.other = `${sel}_other`;
    inputElm.checkbox = `${sel}_checkbox`;

    emailInput.primary = `${emailSel}_primary`;
    emailInput.other = `${emailSel}_other`;

    return (
      <AdvisoryFormWrapper >
        <FormContainer hideRequiredMark>
          <Form>
            <UserInfoForms
              id={tabKey}
              tabKey={tabKey}
              state={this.state}
              props={this.props}
              onChange={this.onChange}
              filterDropDownData={this.filterDropDownData}
              getDateOfBirth={getDateOfBirth}
              handleChange={this.handleChange}
              handleInputBlur={this.handleInputBlur}
              handleDOBChange={this.handleDOBChange}
              getGenderDesc={this.getGenderDesc}
              filterDropDownDataWithValue={this.filterDropDownDataWithValue}
              handleDropDownBlur={this.handleDropDownBlur}
            />
            
            <PhoneForm
              data-test = "phone-form"                          
              phone={ this.state.advisorType === "Primary" ? this.state.primaryAdvisor.phones: this.state.secondaryAdvisor.phones }
              wrappedComponentRef = {phoneRef}
              handleChange = {this.handleFormChange}
              elementIds={inputElm}            
            />

            <EmailForm
                data-test='EmailFormBlock'
                email  = { this.state.advisorType === "Primary" ? this.state.primaryAdvisor.emails: this.state.secondaryAdvisor.emails}
                handleChange = {this.handleFormChangeEmail}                
                wrappedComponentRef = {emailRef}
                elementIds={emailInput}
            />
              
            <AddressForm
              id={tabKey}
              zipCodeData={this.props.zipCodeData}
              resetZipCode={(val, field)=>this.props.resetZipCode(val, field)}
              resetAllZipCode={(val) => this.props.resetAllZipCode(val)}
              storeZipCode = {() => this.storeZipCode()}
              state={this.state}
              sameAddr={this.sameAddr}
              handleDropDownBlur={this.handleDropDownBlur}
              handleDropDownChange={this.handleDropDownChange}
              handleRadioChange={this.handleRadioChange}
              handleRemove={this.handleRemove}
              handleInputBlur={this.handleInputBlur}
              handleArrayChange={this.handleArrayChange}
              dropDownHandleChange={this.dropDownHandleChange}
              handleAddressTypeDropdown={this.handleAddressTypeDropdown}
              handleAddNewField={this.handleAddNewField}
              filterDropDownData={this.filterDropDownData}
              filterDropDownDataWithValue={this.filterDropDownDataWithValue}
            />                  
          </Form>
          {this.state.advisorType === "Primary" ? (
          <RowWrapper>
            <DeliveryMethod
              state={this.state}
              id={tabKey}
              handleOkay={this.handleOkay}
              handleRadioChange={this.handleRadioChange}
              handleViewInfo={this.handleViewInfo}
            />
          </RowWrapper>
          ) : null }
          {this.state.advisorType === "Primary" ? (
            <div>
              {!this.props.disable && (
                  <>
                    <PagesHeading investOnly={true}>
                      Would you like to add a second advisor ?
                    </PagesHeading>
                    <SubContentWrap>
                      Each account may have up to two account advisors. If you select a second advisor, that person will have identical account privileges and access as you. To add a second advisor to the account, please click Add Advisor.
                    </SubContentWrap>

                    <PillButtonGreenWrap marginBottom = "50">
                      <PillButtonGreen
                        onClick={this.handleAddAdvisorClick.bind(this, false)}
                      >
                        Add secondary advisor 
                      </PillButtonGreen>
                    </PillButtonGreenWrap>

                  </>
                )}
            </div>
          ) : (
            <div>
              <DividerWrap>
                <Divider />
              </DividerWrap>
              <PillButtonGreenWrap marginBottom = "50">
                <PillButtonGreen
                  onClick={this.handleRemoveAdvisorClick}
                >
                  Remove Advisor -
                </PillButtonGreen>
              </PillButtonGreenWrap>
            </div>
          )}
          <DividerWrap>
            <Divider />
          </DividerWrap>
          <DisplayFlexSpaceMobile>
            <DisplayFlex>
              {this.props.stepperUpdateIndex.status ? (
                <>
                  <ButtonWrapper marginTop={true} marginRight={true}>
                    <GeneralButton 
                      text = "CANCEL"
                      width = "150px"
                      type = "functional"
                      mobWidth = "100%"
                      inverted = {true}
                      onClick={this.goDirectFinalStep.bind(this)} 
                      id={"btnCancel"+tabKey}
                    />
                  </ButtonWrapper>
                  <ButtonWrapper marginTop={true}>
                    <GeneralButton 
                      text = "CLEAR"
                      width = "150px"
                      type = "functional"
                      inverted = {true}
                      mobWidth = "100%"
                      id={"btnClear"+tabKey}
                      onClick={() =>
                        this.setState({
                          show: true,
                          type: "reset"
                        },() => {
                          window.scrollTo(0, 0);
                        })
                      }
                    />
                  </ButtonWrapper>
                </>
              ) : (
                <>
                   <ButtonWrapper marginTop={true} marginRight={true}>
                      <GeneralButton 
                        text = "EXIT"
                        width = "150px"
                        type = "functional"
                        inverted = {true}
                        mobWidth = "100%"
                        id={"btnExit"+tabKey}
                        onClick={this.handleExit}
                      />
                   </ButtonWrapper>

                   <ButtonWrapper marginTop={true}>
                      <GeneralButton 
                        text = "CLEAR"
                        width = "150px"
                        type = "functional"
                        mobWidth = "100%"
                        inverted = {true}
                        id={"btnClear"+tabKey}
                        onClick={() =>
                          this.setState({
                            show: true,
                            type: "reset"
                          },() => {
                            window.scrollTo(0, 0);
                          })
                        }
                      />
                   </ButtonWrapper>
                </>
              )}
            </DisplayFlex>
            {this.props.stepperUpdateIndex.status ? (
              this.state.step1Edit == true && (
                  ButtonDisplay(
                    this.state.primaryAdvisor,
                    this.state.primaryErrors,
                    this.state.secondaryActive,
                    this.state.secondaryAdvisor,
                    this.state.secondaryErrors
                  ) ? (
                    <ButtonWrapper marginTop={true}>
                      <GeneralButton 
                        text = "UPDATE"
                        width = "150px"
                        mobWidth = "100%"
                        onClick = {this.goToFinalStep.bind(this)}
                        id = {"btnUpdate"+tabKey}
                      />
                    </ButtonWrapper>
                  ) : (
                    <ButtonWrapper marginTop={true}>
                      <GeneralButton 
                        text = "UPDATE"
                        width = "150px"
                        mobWidth = "100%"
                        onClick = {() => this.displayErrorMessages()}
                        id = {"btnUpdate"+tabKey}
                      />
                    </ButtonWrapper>
                  )
              )
            ) : ButtonDisplay(
                this.state.primaryAdvisor,
                this.state.primaryErrors,
                this.state.secondaryActive,
                this.state.secondaryAdvisor,
                this.state.secondaryErrors
              ) ? (
              <ButtonWrapper marginTop={true}>
                <GeneralButton 
                  text = "NEXT"
                  width = "150px"
                  mobWidth = "100%"
                  id = {"btnNext"+tabKey}
                  onClick = {this.goToNextStep.bind(this)}
                />
              </ButtonWrapper>
            ) : (
              <ButtonWrapper marginTop={true}>
                <GeneralButton 
                  text = "NEXT"
                  width = "150px"
                  mobWidth = "100%"
                  onClick = {() => this.displayErrorMessages()}
                  id = {"btnNext"+tabKey}
                />
              </ButtonWrapper>
            )}
          </DisplayFlexSpaceMobile>
        </FormContainer>
      </AdvisoryFormWrapper>
    );
  }

  moveIntoErrorPosition = (errorClassObj) => {
    /** Finding the element for respective className passed as argument into the function */
    let element = document.querySelector(`.ant-tabs-tabpane-active ${errorClassObj.errorClass}`);    
    if(element) {
      /** Calculating top Position from the element to the window */
      let topPos = element.getBoundingClientRect().top + window.pageYOffset; 
      /** Need to subtract to 250px from the top as the element is hidden under header */
      topPos -= 250;
      /** Returns true if it is Internet Explorer */
      if(!!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g)){        
      /** This is to scroll to that position */
        window.scrollTo(0,topPos);
      }else{        
        window.scrollTo({
          top: topPos,
          behavior: 'smooth',
        });
      }
    }
  }

  setErrorMessages = () => { 
    let secondaryAdvisor = Object.assign({},this.state.secondaryAdvisor);
    secondaryAdvisor.confirmSSN = this.state.secondaryConfirmSSN;

    let errorsData = ErrorHandling(1,[
      {fields: this.state.primaryAdvisor, errors: Object.assign({},this.state.primaryErrors)},
      {fields: secondaryAdvisor, errors: Object.assign({},this.state.secondaryErrors)}
    ]);
    /** Checking if the error exists in first tab or both the tabs */
    switch(this.state.tabs.length){
      case 1: 
        this.setState({primaryErrors: errorsData[0]},() => {
          /** Setting the primary advisor error, and scrolling to that postion */
          this.moveIntoErrorPosition({errorClass: '.error-fields-ooa'});
        });
        break;
      default:
        this.setState({primaryErrors: errorsData[0],secondaryErrors: errorsData[1]}, () => {
          /** Setting both the primary/secondary advisor error, and scrolling to that postion */
          this.moveIntoErrorPosition({errorClass: '.error-fields-ooa'});
        });
        break;
    }
  }

  displayErrorMessages = () => {   
    try {
      /** ErrorHandling(a,b)
       *  a - Indicating Step Number
       *  b - [{},{}] - Individual Object contains tab fields value and errors
       */   
      const { primaryAdvisor, secondaryAdvisor, advisorType } = this.state;

      if(advisorType === 'Primary') {        
        if(this.phoneEmailValidation(primaryAdvisor.phones, "phone",true) || this.phoneEmailValidation(primaryAdvisor.emails, "email",true)) {
          this.validateForms().then().catch((err) => this.setErrorMessages() );
         } else {
           this.setErrorMessages();
         }
      } else if(advisorType === 'Secondary') {   
        if(this.phoneEmailValidation(secondaryAdvisor.phones, "phone",true) || this.phoneEmailValidation(secondaryAdvisor.emails, "email",true)) {
          this.validateForms().then().catch((err) => this.setErrorMessages() );
        } else {          
          this.setErrorMessages();
        }
      }
    } catch (error) {
      recordError(error);
    }
  }

  phoneEmailValidation(data, type, isOntabChange = false) {
    if(isOntabChange && data.length === 0){
      return true;
    }
    
    if(type === "phone"){
    let phoneError = data.map(phone => {
        if(phone.phonenumber.trim() === "" && phone.phonetype === "Primary"){
          return true;
        } else {
          return false;
        }
    });
    if(Array.isArray(phoneError) && phoneError.includes(true) === true){
      return true;
    } else {
      return false;
    }
  } else if(type === "email") {
    let emailError = data.map(email => {
        if(email.emailId === "" && email.emailtype === "Primary"){
          return true;
        } else {
          return false;
        }
    });
    if(Array.isArray(emailError) && emailError.includes(true) === true){
      return true;
    } else {
      return false;
    }
  }
  }

  handleErrors = (val, advisorKey, errorKey, type, index) => {
    if(type === 'dob') {      
      let ErrorMsg = ErrorMessage('dobEmpty');
      this.setState(prevState => ({
        [errorKey]: {
          ...prevState[errorKey],
          [type]: {
            ...prevState[errorKey][type],
            [index]: !this.state[advisorKey].dob ? ErrorMsg: null
          }
        }
      }));      
    } else {
      let ErrorMsg = ErrorMessage(type);
      this.setState(prevState => ({
        [errorKey]: {
          ...prevState[errorKey],
          [type]: {
            ...prevState[errorKey][type],
            [index]: !val ? ErrorMsg: null
          }
        }
      }));
    }
  }

  // Blur Functionality Of DropDown (Dynamic)
  handleDropDownBlur = (val, type, index) => {
    if(this.state.advisorType === 'Primary') {
      this.handleErrors(val, 'primaryAdvisor', 'primaryErrors', type, index);
    } else if(this.state.advisorType === 'Secondary') {
      this.handleErrors(val, 'secondaryAdvisor', 'secondaryErrors', type, index);
    }    
  };

  // Blur Functionality For All Input Field
  handleInputBlur = (e, type, index) => {
    // For primary Advisor
    if (this.state.advisorType == "Primary") {
      if (e.target.value == null || e.target.value == "") {
        let ErrorMsg = ErrorMessage(type);
        this.setState(prevState => ({
          primaryErrors: {
            ...prevState.primaryErrors,
            [type]: {
              ...prevState.primaryErrors[type],
              [index]: ErrorMsg
            }
          }
        }));
      }
      if (e.target.value != null && e.target.value != "" && e.target.value.length < 3 && type === "ssn") {
        let ErrorMsg = ErrorMessage(type, "length");
        this.setState(prevState => ({
          primaryErrors: {
            ...prevState.primaryErrors,
            [type]: {
              ...prevState.primaryErrors[type],
              [index]: ErrorMsg
            }
          }
        }));

        if(e.target.value === this.state.secondaryConfirmSSN){
          this.setState(prevState => ({
            secondaryErrors: {
              ...prevState.secondaryErrors,
              confirmSSN: {
                ...prevState.secondaryErrorsconfirmSSN,
                [index]: null
              }
            }
          }));
        }else{
          let ErrorMsg = ErrorMessage("confirmSSN","length");
          this.setState(prevState => ({
            seconadaryErrors: {
              ...prevState.seconadaryErrors,
              [type]: {
                ...prevState.seconadaryErrors[type],
                [index]: ErrorMsg
              }
            }
          }));
        }

      }
      if (
        e.target.value.length > 0 &&
        this.state.primaryAdvisor.ssn &&
        type === "confirmSSN"
      ) {
        if (e.target.value != this.state.primaryAdvisor.ssn && this.state.primaryAdvisor.ssn != "") {
          let ErrorMsg = ErrorMessage(type);
          this.setState(prevState => ({
            primaryErrors: {
              ...prevState.primaryErrors,
              [type]: {
                ...prevState.primaryErrors[type],
                [index]: ErrorMsg
              }
            }
          }));
        } else {
          this.setState(prevState => ({
            primaryErrors: {
              ...prevState.primaryErrors,
              [type]: {
                ...prevState.primaryErrors[type],
                [index]: null
              }
            }
          }));
        }
      }
      if (e.target.value.length > 0 && type === "emailId") {
        if (inputBlurValidation(e.target.value, "emailId") === false) {
          let ErrorMsg = ErrorMessage(type, "format");
          this.setState(prevState => ({
            primaryErrors: {
              ...prevState.primaryErrors,
              [type]: {
                ...prevState.primaryErrors[type],
                [index]: ErrorMsg
              }
            }
          }));
        }
      }
      if (e.target.value.length > 0 && type === "zipcode") {
        if (inputBlurValidation(e.target.value, "zipcode",this.state.primaryAdvisor.addresses[index]) === false) {
          let ErrorMsg = ErrorMessage(type, "length");
          let updatedAddr = JSON.parse(JSON.stringify(this.state.primaryAdvisor.addresses));
          updatedAddr[index].city = null;
          updatedAddr[index].state = null;
          this.setState(prevState => ({
            primaryAdvisor: {
              ...prevState.primaryAdvisor,
              addresses: updatedAddr
            },
            primaryErrors: {
              ...prevState.primaryErrors,
              [type]: {
                ...prevState.primaryErrors[type],
                [index]: ErrorMsg
              }
            }
          }));
        }
      }
      if (e.target.value.length > 0 && e.target.value.length < 2 && type === "firstname") {
        let ErrorMsg = ErrorMessage(type, "length");
        this.setState(prevState => ({
          primaryErrors: {
            ...prevState.primaryErrors,
            [type]: {
              ...prevState.primaryErrors[type],
              [index]: ErrorMsg
            }
          }
        }));
      }
      if (e.target.value.length > 0 && type === "city") {
        if (inputBlurValidation(e.target.value, "city") === false) {
          let ErrorMsg = ErrorMessage(type, "length");
          this.setState(prevState => ({
            primaryErrors: {
              ...prevState.primaryErrors,
              [type]: {
                ...prevState.primaryErrors[type],
                [index]: ErrorMsg
              }
            }
          }));
        }
      }
      if (e.target.value.length > 0 && type === "state") {
        let result = inputBlurValidation(e.target.value, "state");
        if (result === false ) {
          let ErrorMsg = ErrorMessage(type, 'length');
          this.setState(prevState => ({
            primaryErrors: {
              ...prevState.primaryErrors,
              [type]: {
                ...prevState.primaryErrors[type],
                [index]: ErrorMsg
              }
            }
          }));
        }
      }
      if(e.target.value.trim() == ""){
        let ErrorMsg = ErrorMessage(type);
        this.setState(prevState => ({
          primaryErrors: {
            ...prevState.primaryErrors,
            [type]: {
              ...prevState.primaryErrors[type],
              [index]: ErrorMsg
            }
          }
        }));
      }
    }
    // For Secondary Advisor
    else {
      if (e.target.value == null || e.target.value == "") {
        let ErrorMsg = ErrorMessage(type);
        this.setState(prevState => ({
          secondaryErrors: {
            ...prevState.secondaryErrors,
            [type]: {
              ...prevState.secondaryErrors[type],
              [index]: ErrorMsg
            }
          }
        }));
      }
      if (e.target.value.length > 0 && type === "emailId") {
        if (inputBlurValidation(e.target.value, "emailId") === false) {
          let ErrorMsg = ErrorMessage(type, "format");
          this.setState(prevState => ({
            secondaryErrors: {
              ...prevState.secondaryErrors,
              [type]: {
                ...prevState.secondaryErrors[type],
                [index]: ErrorMsg
              }
            }
          }));
        }
      }
      if (e.target.value.length > 0 && type === "zipcode") {
        if (
          inputBlurValidation(
            e.target.value,
            "zipcode",
            this.state.secondaryAdvisor.addresses[index]
          ) === false
        ) {
          let ErrorMsg = ErrorMessage(type, "length");
          let updatedAddr = JSON.parse(JSON.stringify(this.state.secondaryAdvisor.addresses));
          updatedAddr[index].city = null;
          updatedAddr[index].state = null;
          this.setState(prevState => ({
            secondaryAdvisor: {
              ...prevState.secondaryAdvisor,
              addresses: updatedAddr 
            },
            secondaryErrors: {
              ...prevState.secondaryErrors,
              [type]: {
                ...prevState.secondaryErrors[type],
                [index]: ErrorMsg
              }
            }
          }));
        }
      }
      if (e.target.value.length > 0 && e.target.value.length < 2 && type === "firstname") {
        let ErrorMsg = ErrorMessage(type, "length");
        this.setState(prevState => ({
          secondaryErrors: {
            ...prevState.secondaryErrors,
            [type]: {
              ...prevState.secondaryErrors[type],
              [index]: ErrorMsg
            }
          }
        }));
      }
      if (e.target.value.length > 0 && e.target.value.length < 2 && type === "lastname") {
        let ErrorMsg = ErrorMessage(type, "length");
        this.setState(prevState => ({
          secondaryErrors: {
            ...prevState.secondaryErrors,
            [type]: {
              ...prevState.secondaryErrors[type],
              [index]: ErrorMsg
            }
          }
        }));
      }
      if (e.target.value.length > 0 && type === "city") {
        if (inputBlurValidation(e.target.value, "city") === false) {
          let ErrorMsg = ErrorMessage(type, "length");
          this.setState(prevState => ({
            secondaryErrors: {
              ...prevState.secondaryErrors,
              [type]: {
                ...prevState.secondaryErrors[type],
                [index]: ErrorMsg
              }
            }
          }));
        }
      }
      if (e.target.value.length > 0 && type === "state") {
        if (inputBlurValidation(e.target.value, "state") === false) {
          let ErrorMsg = ErrorMessage(type, "length");
          this.setState(prevState => ({
            secondaryErrors: {
              ...prevState.secondaryErrors,
              [type]: {
                ...prevState.secondaryErrors[type],
                [index]: ErrorMsg
              }
            }
          }));
        }
      }

      if(type === "ssn"){
        if (e.target.value != null && e.target.value != "" && e.target.value.length < 3) {
          let ErrorMsg = ErrorMessage(type, "length");
          this.setState(prevState => ({
            secondaryErrors: {
              ...prevState.secondaryErrors,
              [type]: {
                ...prevState.secondaryErrors[type],
                [index]: ErrorMsg
              }
            }
          }));
        }
  
        if(this.state.secondaryConfirmSSN && e.target.value !== this.state.secondaryConfirmSSN && this.state.secondaryConfirmSSN.trim() !== ""){
          let ErrorMsg = ErrorMessage("confirmSSN","length");
            this.setState(prevState => ({
              secondaryErrors: {
                ...prevState.secondaryErrors,
                confirmSSN: {
                  ...prevState.secondaryErrorsconfirmSSN,
                  [index]: ErrorMsg
                }
              }
            }));
        }
      }

      
      if (e.target.value.length > 0 && type === "confirmSSN") {
        if (this.state.secondaryAdvisor.ssn && e.target.value !== this.state.secondaryAdvisor.ssn &&  this.state.secondaryAdvisor.ssn.trim() !== "") {
          let ErrorMsg = ErrorMessage(type,"length");
          this.setState(prevState => ({
            secondaryErrors: {
              ...prevState.secondaryErrors,
              [type]: {
                ...prevState.secondaryErrors[type],
                [index]: ErrorMsg
              }
            }
          }));
        }
      }
      if(e.target.value.trim() == ""){
        let ErrorMsg = ErrorMessage(type);
        this.setState(prevState => ({
          secondaryErrors: {
            ...prevState.secondaryErrors,
            [type]: {
              ...prevState.secondaryErrors[type],
              [index]: ErrorMsg
            }
          }
        }));
      }
      if(type === "ssn"){
        if(e.target.value === this.state.secondaryConfirmSSN){
          this.setState(prevState => ({
            secondaryErrors: {
              ...prevState.secondaryErrors,
              confirmSSN: {
                ...prevState.secondaryErrorsconfirmSSN,
                [index]: null
              }
            }
          }));
        }
      }
    }

    if(type === "name"){
      if(e.target.value.trim() == ""){
        let ErrorMsg = ErrorMessage(type);
        this.setState(prevState => ({
          primaryErrors: {
            ...prevState.primaryErrors,
            [type]: {
              ...prevState.primaryErrors[type],
              [index]: ErrorMsg
            }
          }
        }));
      }else{
        this.setState(prevState => ({
          primaryErrors: {
            ...prevState.primaryErrors,
            [type]: {
              ...prevState.primaryErrors[type],
              [index]: null
            }
          }
        }));
      }
    }
  };

  handleOkay = () => {
    this.setState({ showInfo: false });
  };

  handleViewInfo = () => {
    this.setState({ showInfo: true });
  };

  //Switching between Tabs
  onChangeTabs(activeKey) {
    const { primaryAdvisor, secondaryAdvisor } = this.state;
    if (activeKey == "Primary") {
      this.setState({ advisorType: "Primary", secondaryActive: false}, () => {         
          if(this.phoneEmailValidation(primaryAdvisor.phones, "phone") || this.phoneEmailValidation(primaryAdvisor.emails, "email")) {
            this.validateForms();
        } 
      });
    } else {
      this.setState({ advisorType: "Secondary", secondaryActive: true}, () => {         
          if(this.phoneEmailValidation(secondaryAdvisor.phones, "phone") || this.phoneEmailValidation(secondaryAdvisor.emails, "email")) {      
          this.validateForms();
        }
      });
    }
    this.setState({ activeKey });
  }

  //Closing Popup Modal
  closeModal() {
    this.setState({
      show: false
    });
  }

  handleExitClick = () => {
    this.analyticsTracking('exit','Step 1 Provide account information','Exit');
    this.setState({
      show: !this.state.show
    });
    this.props.resetFormData();
    this.props.resetStepperIndex();
    history.push("/");
  };

  //Clearing All Fields
  handleResetUserData() {
    let advisorData = {};
    if (this.state.advisorType == "Primary") {
      advisorData = JSON.parse(JSON.stringify(this.state.primaryAdvisor));
      advisorData.firstname = this.state.tempInfo.firstname == null ? null : this.state.tempInfo.firstname;
      advisorData.middlename = this.state.tempInfo.middlename == null ? null : this.state.tempInfo.middlename;
      advisorData.lastname = this.state.tempInfo.lastname == null ? null : this.state.tempInfo.lastname;
      advisorData.dob = this.state.tempInfo.dob == null ? null : this.state.tempInfo.dob;
      advisorData.suffix = this.state.tempInfo.suffix == null ? undefined : this.state.tempInfo.suffix;
      advisorData.gender = this.state.tempInfo.gender == null ? undefined : this.state.tempInfo.gender;
      advisorData.title = this.state.tempInfo.title == null ? undefined : this.state.tempInfo.title;
    } else {
      advisorData = JSON.parse(JSON.stringify(this.state.secondaryAdvisor));
      advisorData.deliveryMethod = "E-Delivery";
      advisorData.dob = "";
      advisorData.firstname = null;
      advisorData.gender = "";
      advisorData.lastname = null;
      advisorData.middlename = null;
      advisorData.ssn = null;
      advisorData.suffix = "";
      advisorData.title = "";
    }

    advisorData.addresses = [
      {
        addressId: 0,
        addresstype: undefined,
        city: null,
        country: undefined,
        line1: null,
        line2: null,
        line3: null,
        state: undefined,
        zipcode: null,
        primary: true
      }
    ];

    advisorData.emails = [];
    advisorData.phones = [];

    if (
      this.state.advisorType == "Primary" &&
      advisorData.relatedDonor.length != 0
    ) {
      advisorData.relatedDonor = [
        {
          name: null,
          relationship: undefined
        }
      ];
    }

    if (this.state.advisorType == "Primary") {
      this.setState(
        prevState => ({
          primaryAdvisor: advisorData,
          tempToDisplayOnly: {
            ...prevState.tempToDisplayOnly,
            primaryTitle: undefined,
            primarySuffix: undefined,
            primaryGender: undefined
          },
          primaryErrors: {}
        }),
        () => {
          this.closeModal();
          this.state.tabs[0].phoneRef.current.form.resetFields();
          this.state.tabs[0].emailRef.current.form.resetFields();
        }
      );
    } else {
      this.setState(
        prevState => ({
          secondaryAdvisor: advisorData,
          tempToDisplayOnly: {
            ...prevState.tempToDisplayOnly,
            secondaryTitle: undefined,
            secondarySuffix: undefined,
            secondaryGender: undefined
          },
          checkedEmail:false,
          addressChecked:false,
          secondaryConfirmSSN: null,
          secondaryErrors: {}
        }),
        () => {
          this.closeModal();
          this.state.tabs[1].phoneRef.current.form.resetFields();
          this.state.tabs[1].emailRef.current.form.resetFields();
        }
      );
    } 
  }

  handleAddressTypeDropdown = (dropdown = [],adress,index)=>{
    let addressTypeList = adress.filter((addr,addrIndex)=>{
      return  addrIndex != index;
    });
   return dropdown.filter((val)=>{
      return !addressTypeList.some((element)=>{
        return element.addresstype == val.desc
      })
    })
  }

  handleFormChange = (values)=>{    
    values['phones'] = values['phone']; // Assign new key
    delete values['phone']; // Delete old key
    if (this.state.advisorType === "Primary") {
    this.setState({
      primaryAdvisor: {...this.state.primaryAdvisor,...values}
      }
    );
    }else {
      this.setState({
        secondaryAdvisor: {...this.state.secondaryAdvisor,...values}
        }
      );
    }
  }
  handleFormChangeEmail = (values)=>{
    values['emails'] = values['email']; // Assign new key
    delete values['email']; // Delete old key
    if (this.state.advisorType === "Primary") {
    this.setState({
      primaryAdvisor: {...this.state.primaryAdvisor,...values}
      }
    );
  }else {
    this.setState({
      secondaryAdvisor: {...this.state.secondaryAdvisor,...values}
      }
    );
  }
  }

  validateForms = () => {    
    const { tabs, advisorType } = this.state;
    const { validateFields: validatePrimaryPhone } = tabs[0].phoneRef.current.form;    
    const { validateFields: validatePrimaryEmail } = tabs[0].emailRef.current.form;

    if(tabs.length === 2 && advisorType === 'Secondary') {      
      const { validateFields: validateSecPhone } = tabs[1].phoneRef.current.form;
      const { validateFields: validateSecEmail } = tabs[1].emailRef.current.form;
      return Promise.all([validateSecPhone(), validateSecEmail()]);
    }

    return Promise.all([validatePrimaryPhone(), validatePrimaryEmail()]);    
  }

  render() {
    const TabPane = Tabs.TabPane;
    const { alertOOA } = this.props;
    const { alertsStatus, exitPopupContent, removePopupContent, resetPopupContent } = this.state;
    if(alertOOA && alertOOA.length && !alertsStatus){
      this.setState({
        resetPopupContent: mapContents(getAlert(alertOOA,'Reset Information'), resetPopupContent),
        removePopupContent: mapContents(getAlert(alertOOA,'Remove secondary advisor'), removePopupContent),
        exitPopupContent: mapContents(getAlert(alertOOA,'Exit'), exitPopupContent),
        alertsStatus: true
      })
    }
    return (
      <div>
        {this.state.type == "exit" && this.state.show == true && (
          <Popup
            height="313px"
            width="481px"
            mwidth="88%"
            mheight="53%"
            content={exitPopupContent}
            closeModal={this.closeModal.bind(this)}
            handleExitClick={() => this.handleExitClick()}
            data-test="popup_component_exit"
          />
        )}

        {this.state.type == "remove" && this.state.show == true && (
          <Popup
            height="313px"
            width="481px"
            mwidth="88%"
            mheight="53%"
            content={removePopupContent}
            closeModal={this.closeModal.bind(this)}
            advisorType={this.advisorType}
            handleRemove={() => this.removeTab()}
            data-test="popup_component_remove"
          />
        )}

        {this.state.type == "reset" && this.state.show == true && (
          <Popup
            height="313px"
            width="481px"
            mwidth="88%"
            mheight="53%"
            content={resetPopupContent}
            closeModal={this.closeModal.bind(this)}
            advisorType={this.state.advisorType}
            handleReset={this.handleResetUserData.bind(this)}
            handleResetSecondary={this.handleResetUserData.bind(this)}
            data-test="popup_component_reset"
          />
        )}

        {/* Start Of Rendering Step 1 Setup */}
        <SelectTabsWrapper>
          <Tabs
            hideAdd
            onChange={this.onChangeTabs.bind(this)}
            activeKey={this.state.activeKey}
            type="card"
          >
            {this.state.tabs.map((pane, index) => {
              return (
                <TabPane key={pane.key} tab={pane.title} id={"tbCardTab"+index}>
                  {this.renderingHeaderAndFooter(pane)}
                </TabPane>
              );
            })}
          </Tabs>
        </SelectTabsWrapper>
      </div>
    );
  }
}

export const mapDispatchToProps = dispatch => {
  return {
    disableButton: val => dispatch(disableButton(val)),
    isSecondaryAdvisor: val => dispatch(isSecondaryAdvisor(val)),
    updateReducerAdvisor: val => dispatch(updateReducerAdvisor(val)),
    updateStepperIndex: val => dispatch(updateStepperIndex(val)),
    editStepperIndex: val => dispatch(editStepperIndex(val)),
    jsonTempForStep1: val => dispatch(jsonTempForStep1(val)),
    finishActivePageStep: () => dispatch(updatePageStepToFinish()),
    updateStepperAllToFinish: data => dispatch(updateStepperAllToFinish(data)),
    resetFormData: () => dispatch(resetFormData()),
    resetStepperIndex: () => dispatch(resetStepperIndex()),
    resetZipCode: (val, field) => dispatch(resetZipCode(val, field)),
    resetAllZipCode: (val) => dispatch(resetAllZipFields(val))
  };
};

const mapStateToProps = state => ({
  primaryAdvisorEmail: state.getIn([
    "npaFormReducer",
    "primaryAdvisor",
    "email",
    "email"
  ]),
  primaryAdvisorPhone: state.getIn([
    "npaFormReducer",
    "primaryAdvisor",
    "phone",
    "phone"
  ]),
  primaryAdvisorAddress: state.getIn([
    "npaFormReducer",
    "primaryAdvisor",
    "addresses",
    "addresses"
  ]),
  primaryAdvisorRelatedDonor: state.getIn([
    "npaFormReducer",
    "primaryAdvisor",
    "relatedDonor",
    "relatedDonor"
  ]),
  secondaryAdvisorPhone: state.getIn([
    "npaFormReducer",
    "secondaryAdvisor",
    "phone",
    "phone"
  ]),
  secondaryAdvisorEmail: state.getIn([
    "npaFormReducer",
    "secondaryAdvisor",
    "email",
    "email"
  ]),
  secondaryAdvisorAddress: state.getIn([
    "npaFormReducer",
    "secondaryAdvisor",
    "addresses",
    "addresses"
  ]),
  secondaryAdvisorRelatedDonor: state.getIn([
    "npaFormReducer",
    "secondaryAdvisor",
    "relatedDonor",
    "relatedDonor"
  ]),
  disable: state.getIn(["npaFormReducer", "primaryAdvisor", "disable"]),
  dropDown: state.getIn(["npaFormReducer", "dropdownValues", "data"]),
  primaryAdvisorInfo: state.getIn(["npaFormReducer", "primaryAdvisor", "info"]),
  tempInfo: state.getIn(["npaFormReducer", "tempInfo"]),
  status: state.getIn(["npaFormReducer", "status"]),
  secondaryAdvisorInfo: state.getIn([
    "npaFormReducer",
    "secondaryAdvisor",
    "info"
  ]),
  activePageStepNumber: state.getIn(["globalState", "activePageStepNumber"]),
  stepperConfig: state.getIn(["globalState", "stepperConfig"]),
  stepperUpdateIndex: state.getIn(["globalState", "stepperUpdateIndex"]),
  stepperEditIndex: state.getIn(["globalState", "stepperEditIndex"]),
  tempData: state.getIn(["npaFormReducer", "tempJSON", "tempJSON"]),
  zipCodeData: state.getIn(['zipCode', 'zipCodes']).toJS(),
  alertOOA: state.getIn(['npaFormReducer','alerts'])
});

StepOneSetup.propTypes = {
  activePageStepNumber: PropTypes.number,
  alertOOA: PropTypes.any,
  disable: PropTypes.any,
  disableButton: PropTypes.func,
  dropDown: PropTypes.any,
  editStepperIndex: PropTypes.func,
  finishActivePageStep: PropTypes.func,
  isSecondaryAdvisor: PropTypes.func,
  jsonTempForStep1: PropTypes.func,
  location: PropTypes.any,
  primaryAdvisorAddress: CustomPropTypes.addressInfo,
  primaryAdvisorEmail: CustomPropTypes.basicEmailInfo,
  primaryAdvisorInfo: CustomPropTypes.basicInfo,
  primaryAdvisorPhone: CustomPropTypes.basicPhoneInfo,
  primaryAdvisorRelatedDonor: CustomPropTypes.basicRelatedDonor,
  resetAllZipCode: PropTypes.func,
  resetFormData: PropTypes.func,
  resetStepperIndex: PropTypes.func,
  resetZipCode: PropTypes.func,
  secondaryAdvisorAddress: CustomPropTypes.addressInfo,
  secondaryAdvisorEmail: CustomPropTypes.basicEmailInfo,
  secondaryAdvisorInfo: CustomPropTypes.basicInfo,
  secondaryAdvisorPhone: CustomPropTypes.basicPhoneInfo,
  secondaryAdvisorRelatedDonor: PropTypes.any,
  status: PropTypes.string,
  stepperConfig: CustomPropTypes.basicStepperConfig,
  stepperEditIndex: PropTypes.any,
  stepperUpdateIndex: PropTypes.any,
  tempData: PropTypes.any,
  tempInfo: CustomPropTypes.basicInfo,
  updateReducerAdvisor: PropTypes.func,
  updateStepperAllToFinish: PropTypes.func,
  updateStepperIndex: PropTypes.func,
  zipCodeData: PropTypes.object,
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StepOneSetup);